import React from 'react'

import './project.css'
function Project3(){
    return(
        <div className='about-me_container'>
            <div className ='content'>
                <div className='about-me'>
                <div>
                <h1>About me</h1>
                <div className='about-me-text'>
                Little me was eager to show my new ultimate Lego robot to my parents, and after years, the same enthusiasm embraced me when my version of the Wall- E robot traced the black and white maze, avoiding objects. That’s where I decided to play with electronic circuits implementing real-world applications. 
                I am capable of adapting to new environments quickly and effectively. 
                I have a habit of trying out new methods, while improving myself and correcting my mistakes eagerly. 
                With all my passions, my main intention is to share and use my knowledge and experiences for the betterment of humankind

                </div>
                </div>
                
                <img src='/image-5.png' className='wrapper' alt=""/>
                </div>
                
                 
            </div>
        </div>
    )
}
export default Project3;